import { Component, OnInit } from '@angular/core';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {

  public userForm: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;
  public selectedFile: any;
  public imgURL: any;

  constructor(private formBuilder: FormBuilder,
    public http: HttpClient,
    private toastr: ToastrService,
    public route: ActivatedRoute,
    public service: AmbitService) {}

  ngOnInit() {
    this.userForm = this.formBuilder.group({
      userName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(20)]],
      email: ['', Validators.compose([
        Validators.required,
        Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'),
      ])],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]],
      dob: ['', Validators.required],
      profileImage: [''],
      phoneNo: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(14)]],
    });
  }

  get f() { return this.userForm.controls; }

  isValidBirthday() {
    var sDt = new Date(this.userForm.get('dob').value), cDt = new Date(), cYear = cDt.getFullYear(),
      sYear = sDt.getFullYear() + 17, cMonth = cDt.getMonth(), sMonth = sDt.getMonth();
    return (cYear > sYear || (cYear == sYear && (cMonth > sMonth || (cMonth == sMonth && cDt.getDate() >= sDt.getDate()))));
  }

  onChangeFile(event: EventTarget) {

    let eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    let target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    this.selectedFile = target.files[0];
    this.userForm.get("profileImage").setValue(this.selectedFile);

    const file = target.files[0];
    const reader = new FileReader();
    reader.onload = e => this.imgURL = reader.result;

    reader.readAsDataURL(file);

  }

  submitUserData() {
    var self = this;
    self.submitted = true;
    if (this.userForm.valid && this.selectedFile) {
      self.submitted = false;
      self.loading = true;
      var data = self.userForm.value;
      var createUser = firebase.functions().httpsCallable('createUser');
      createUser({
        name: data.userName,
        email: data.email,
        password: data.password,
      }).then((result) => {
        if (result.data.status == 200) {
          self.uploadPhoto(result.data.data.uid);
        } else {
          self.loading = false;
          self.toastr.error(result.data.data.errorInfo.message, '', { timeOut: 4000 });
        }
      }).catch((error) => {
        self.loading = false;
        self.toastr.error(error.message, '', { timeOut: 4000 });
      });

    }
  }

  uploadImageFile(formData: FormData) {
    return this.http.post("https://codexia.xyz/ambit/upload.php", formData).toPromise();
  }

  uploadPhoto(userId: any) {
    var self = this;
    var formDataIntroV: FormData = new FormData();
    formDataIntroV.append('file', this.selectedFile);
    this.uploadImageFile(formDataIntroV).then((res: any) => {
      if (res.success) {
        self.saveUserData(res.fileUrl, userId);
      } else {
        self.loading = false;
        self.toastr.error(res.message, '', { timeOut: 4000 });
      }
    }).catch(err => {
      self.loading = false;
      self.toastr.error("Error Uploading Image", '', { timeOut: 4000 });
    });

  }

  saveUserData(url: any, uid: any) {

    var self = this, data = self.userForm.value;
    var formData = {
      userName: data.userName,
      birthday: data.dob,
      phoneNumber: data.phoneNo,
      email: data.email,
      profileUrl: url,
      driver: false,
      status: true,
      uid: uid,
    };

    var updates = {} ;
    updates['/Users/' + uid] = formData;
    firebase.database().ref().update(updates).then(() => {
      if(!self.service.passengersList) { self.service.passengersList = [] } ;
      self.service.passengersList.push(formData) ;
      self.userForm.reset();
      document.getElementById('closeAddUserMd').click();
      self.toastr.success('New User Account created.', '', { timeOut: 4000 });
    }).catch((err) => {
      self.loading = false;
      self.toastr.error('User account data is not saved.', '', { timeOut: 4000 });
    });

  }

}